const timeChe = {
  gettimeChe(time) {
    var res = ''
    switch (time) {
      case '24':
        res = time + '時(0時)'
        break
      case '25':
        res = time + '時(1時)'
        break
      case '26':
        res = time + '時(2時)'
        break
      case '27':
        res = time + '時(3時)'
        break
      case '28':
        res = time + '時(4時)'
        break
      case '29':
        res = time + '時(5時)'
        break
      case '30':
        res = time + '時(6時)'
        break
      case '31':
        res = time + '時(7時)'
        break
      case '32':
        res = time + '時(8時)'
        break
      default:
        res = time + '時'
    }
    return res
  }
}

export default timeChe



// WEBPACK FOOTER //
// ./src/assets/js/timeChe.js